const STORE_NAME = import.meta.env.VITE_REACT_APP_NAME as string;

interface ICheckSocialLogin {
  loginType: "email" | "kakao" | "google" | "facebook" | "naver" | "apple";
  isDeactivated: boolean;
  isBlocked: boolean;
}

export const checkSocialLogin = async ({
  email,
  domain,
}: {
  email: string;
  domain: "ko" | "en" | "jp";
}): Promise<ICheckSocialLogin | undefined> => {
  try {
    const url = "https://ompv4c3q4v4ncyzcybojlahr5i0tuwvt.lambda-url.ap-northeast-2.on.aws/"; // common_sns_check
    const response = await fetch(url, {
      method: "POST",
      body: JSON.stringify({ storeName: STORE_NAME, domain, email }),
    }).then((res) => res);
    if (response.status === 200) {
      return (await response.json()) as ICheckSocialLogin;
    }
  } catch (error) {
    const message = error instanceof Error ? error.message : String(error);
    throw new Error(message);
  }
};
